import DefaultLayout from "../../../layouts/DefaultLayout";
import {Table} from "../../tables/BasicTable";
import {useContext, useEffect, useState} from "react";
import {useAuth} from "../../../providers/authProvider";
import BoxLayout from "../../../layouts/BoxLayout";
import DefaultButton from "../../buttons/DefaultButton";
import NewUserModal from "../../modals/NewUserModal";
import {ApiContext} from "../../contexts/ApiContext";
import EditUserModal from "../../modals/EditUserModal";
import ConfirmButton from "../../common/ConfirmButton";
import EditButton from "../../buttons/EditButton";

function AdminUsersPage() {

    const {Url} = useContext(ApiContext)
    const {token} = useAuth();
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(false)
    const [openAddUserModal, setOpenAddUserModal] = useState(false);
    const [openEditUserModal, setOpenEditUserModal] = useState(false);
    const [rowData, setRowData] = useState([])
    const [dataAvalible, setDataAvalible] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const [message, setMessage] = useState('')
    const [refreshTrigger, setRefreshTrigger] = useState(0)

    const getColumns = () => [
        {
            Header: "ID",
            accessor: "ID",
        },
        {
            Header: "Voornaam",
            accessor: "FirstName",
        },
        {
            Header: "Achternaam",
            accessor: "LastName",
        },
        {
            Header: "Email",
            accessor: "Email",
        },
        {
            Header: "Telefoonnummer",
            accessor: "Phone",
        },
        {
            Header: "Admin",
            accessor: "Admin",
        },
        {
            Header: "Acties",
            id: "actions",
            Cell: ({row}) => (
                <div className="flex gap-2">
                    <EditButton
                        onClick={() => {
                            setRowData(row.original);
                            setOpenEditUserModal(true);
                        }}
                    />
                </div>
            ),
        },
    ];


    useEffect(() => {
        if (token && !openAddUserModal && !openEditUserModal) {
            setLoading(true)
            fetch(Url + 'admin/users', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) => {
                    if (res.status !== 200) {
                        setDataAvalible(false)
                        if (res.status === 401) {
                            //Unauthorized
                        }
                    } else {
                        setDataAvalible(true)
                    }
                    return res.json()
                })
                .then((data) => {
                    setUsers(data)
                })
                .finally(() => {
                    setLoading(false)
                })
        }

    }, [token, Url, openAddUserModal, openEditUserModal, refreshTrigger]);
    const [table, setTable] = useState(null)

    const handleDeleteAllUserData = () => {
        setLoading(true)
        setMessage('')
        fetch(Url + 'admin/all-user-data', {
            method: 'DELETE',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setMessage(data.message)
                setRefreshTrigger((prev) => prev + 1)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const handleExportUsersWithHomeVisits = () => {
        setLoading(true)
        setMessage('')
        fetch(Url + 'admin/users-with-homevisits-export', {
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + token,
            },
        })
            .then((res) => {
                if (res.ok) {
                    return res.blob()
                }
                throw new Error('Export failed')
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `users_with_homevisits_${new Date().toISOString().split('T')[0]}.xlsx`
                document.body.appendChild(a)
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
                setMessage('Export successful')
            })
            .catch((error) => {
                setMessage('Export failed: ' + error.message)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        if (dataAvalible) {
            setTable(<Table tableData={users} setRowdata={setRowData} getColumns={getColumns()} pageIndex={pageIndex} setPageIndex={setPageIndex} storageKey="users"/>)
        } else {
            setTable(<BoxLayout>
                <div>User data niet beschikbaar of je hebt geen rechten om deze informatie te bekijken.</div>
            </BoxLayout>)
        }
    }, [dataAvalible, users, pageIndex])
    return (
        <DefaultLayout>
            <div className="mb-4 flex gap-4">
                {dataAvalible && <DefaultButton content="Nieuwe gebruiker" onClick={() => setOpenAddUserModal(true)}
                                                disabled={false}></DefaultButton>}
                {dataAvalible && (
                    <DefaultButton 
                        content="Export gebruikers met huisbezoek" 
                        onClick={handleExportUsersWithHomeVisits}
                        disabled={loading}
                    />
                )}
                {dataAvalible && (
                    <ConfirmButton
                        content="Alle gebruikersdata verwijderen"
                        confirmText="WEET JE HET ZEKER? Dit verwijdert alle gebruikers, bedrijfsbezoeken en huisbezoeken (behalve admin accounts)!"
                        onConfirm={handleDeleteAllUserData}
                        disabled={loading}
                        className="bg-red-600 hover:bg-red-700 text-white"
                    />
                )}
            </div>
            {message && (
                <p className="mb-4 text-base leading-relaxed text-red-500">{message}</p>
            )}

            <NewUserModal openModal={openAddUserModal} setOpenModal={() => setOpenAddUserModal()}/>
            <EditUserModal openModal={openEditUserModal} setOpenModal={() => setOpenEditUserModal()} rowData={rowData}/>
            {loading && !dataAvalible ? (
                <BoxLayout>
                    <div>Loading...</div>
                </BoxLayout>

            ) : (
                <div className="flex flex-col overflow-auto py-4 sm:py-0">
                    {table}
                </div>
            )}
        </DefaultLayout>
    )
}

export default AdminUsersPage